import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getJsonMenu } from '../components/organisms/SideMenu/integracion';

const MenuContext = createContext({ menuData: [], refreshMenu: () => {} });

export const MenuProvider = ({ children }) => {
    const [menuData, setMenuData] = useState([]);

    const cargarMenu = useCallback(async () => {
        try {
            const data = await getJsonMenu();
            setMenuData(JSON.parse(data.JSON_MENU));
        } catch (e) {
            console.error('Error cargando menú:', e);
        }
    }, []);

    useEffect(() => {
        cargarMenu();
    }, [cargarMenu]);

    return (
        <MenuContext.Provider value={{ menuData, refreshMenu: cargarMenu }}>
            {children}
        </MenuContext.Provider>
    );
};

export const useMenu = () => useContext(MenuContext);
